import WebinarListCard from "../../../webinar/list/common/Webinar";

export default function Webinar({ webinar }) {
	return <WebinarListCard webinar={webinar} />;
}
